export const OutlinedSvgs = [
  'Archive',
  'Assessment',
  'Assign',
  'Audio',
  'Bookmark',
  'Calculator',
  'Calendar',
  'Claim',
  'ClaimHelp',
  'Classes',
  'Completed',
  'Counterargument',
  'CSK',
  'Curriculum',
  'CustomLesson',
  'CustomLessonDelete',
  'CustomLessonUpdate',
  'DirectInstruction',
  'Educator',
  'Evidence',
  'EvidenceAndReasoning',
  'EvidenceHelp',
  'ELA',
  'Favorite',
  'GoTo',
  'InProgress',
  'Info',
  'InfoOutlined',
  'Key',
  'Language',
  'LongerWorks',
  'ThinkCERCA',
  'Next',
  'NotAvailable',
  'PaperDoc',
  'Preview',
  'Reading',
  'ReadingStrand',
  'Reason',
  'ReasonHelp',
  'Reasoning',
  'ReasoningHelp',
  'Reports',
  'Science',
  'Search',
  'Settings',
  'SocialStudies',
  'SpeakingAndListening',
  'SummarizeSentences',
  'Students',
  'Time',
  'Tips',
  'VerticalDots',
  'View',
  'Welcome',
  'Writing',
  'WritingModule',
  'WritingStrand',
]

export const SolidSvgs = [
  'ArchiveSolid',
  'AudioSolid',
  'BookmarkSolid',
  'EditSolid',
  'EditPhotoSolid',
  'GoToSolid',
  'InfoSolid',
  'MoreSolid',
  'NextSolid',
  'NotificationSolid',
  'ProfileSolid',
  'ReportsSolid',
  'SettingsSolid',
  'SpeechBubble',
  'ViewSolid',
  'ThinkCERCASolid',
]

export const Csk2Svgs = [
  'ArrowDown',
  'ArrowUp',
  'CarrotLeft',
  'CarrotRight',
  'Checkmark',
  'CloseX',
  'Correct',
  'CorrectPractice',
  'CorrectPracticeColor',
  'CorrectQuiz',
  'Delete',
  'Hints',
  'List1',
  'List2',
  'List3',
  'List4',
  'NoRetry',
  'Points',
  'PointsCircled',
  'PointsSolid',
  'Retry',
  'Retry1',
  'Retry2',
  'Retry3',
  'Retry4',
  'Wrong',
]

const IconSvgs = OutlinedSvgs.concat(SolidSvgs)
  .concat(Csk2Svgs)
  .sort()

export default IconSvgs
